var base = require('auth/register-stripe');

Vue.component('spark-register-stripe', {
    mixins: [base],
    props: ['predefined_email', 'ch'],
    mounted() {
      if (this.predefined_email) {
        this.registerForm.email = this.predefined_email
      }
    }
});
